















const ExcelJS = require("exceljs");

import { Component, Watch, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { BPagination } from "bootstrap-vue";
import Header from "@/components/Header.vue";
import EntityTabs from "@/components/EntityTabs.vue";
import MemberSearch from "@/components/report/MemberSearch.vue";
import ListView from "@/components/report/MemberList.vue";
import { GapReportFilter } from "@/store/modules/types";
import App from "@/App.vue";

@Component({
  components: {
    BPagination,
    Header,
    EntityTabs,
    MemberSearch,
    /*     Pager,
    CalendarView, */
    ListView,
  },
  computed: {
    ...mapState("gaps", ["filter"]),
    /*  ...mapState("schedule", ["view", "list"]), */
    /*getDefaulthCampaign: function () {
      return this.$store.state.gaps.campaigns[0].id;
    },*/
  },
})
export default class MembersReport extends Vue {
  campaignId: string = "";
  filter!: GapReportFilter;
  pageRows: Array<any> = [];
  @Watch("filter", { deep: true })
  onFilterChanged() {
    this.getReport();
  }

  defaultFilter(): GapReportFilter {
    return {
      insurerList: [],
      ipaList: [],
      priorityList: [],
      statusList: [],
      subStatusList: [],
      admissionDischargeList:[],
      referenceDate: {
        to: null,
        from: null,
      },
      campaignId: this.getDefaulthCampaign.id,
    };
  }

  async getReport() {
    this.$store.commit("main/SET_LOADING", true);
    const { campaignId } = this.filter;
    try {
      const data = await this.$store.dispatch(
        "gaps/getMembersReport",
        campaignId
      );
      this.pageRows = data;
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }

  get getDefaulthCampaign() {
    return this.$store.state.gaps.campaigns[0];
  }

   get getCampaignSelected() {
    return this.$store.state.gaps.campaigns.filter((c) => c.id === this.filter.campaignId)[0];
  }

  get getEntity() {
    return this.$store.state.auth.user.entities.filter(
      (e) => e.id == this.$store.state.auth.entityId
    )[0];
  }

  exportExcel() {
    /*const store = this.$store;
    this.$store.commit("main/SET_LOADING", true);*/
    var reportTitle = "MEMBERS REPORT";
    var subtitle = this.getCampaignSelected.name;
    var fileName =
      "members_report_dateFrom_" + this.$moment().format("MMDDYYYY_hhmma");
    const reportDate = this.$moment()
      .format("MMM DD YYYY hh:mm A")
      .toUpperCase();
    const reportRangeDate ="";
      /*"FROM " +
      this.$moment().format("MM/DD/YYYY") +
      " TO " +
      this.$moment().format("MM/DD/YYYY");*/
    const medicalOffice = this.getEntity.name;
    //const calendar = this.report[0].Calendar.toUpperCase();
    // const waitingList = this.report[0].WaitingList.toUpperCase();
    const header = [
      "Insurer",
      "Member ID",
      "Member Name",
      "Group Number",
      "Group Name",
      "IPA Number",
      "IPA Name",
      "PCP NPI",
      "PCP Name",
      "Sex",
      "Birthdate",
      "Stage",
      "Status",
      "Status Contact",
      "Status Reason",
      "Call Status",
      "Reference Date",
      "Status in Program",
      "Date Admission",
      "Date Discharge",
      "Evaluation Date",
      "Comment 1",
      "Comment 2",
      "Comment 3",
      "Comment 4",
    ];
    const font = {
      name: "Calibri",
      family: 2,
      size: 16,
      underline: false,
      bold: true,
    };
    const alignment = {
      vertical: "middle",
      horizontal: "right",
    };
    const data: any = [];
    var total = 0;
    const moment: any = this.$moment;
    for (const member of this.pageRows) {
      var row: any = [];
      row.push(member.Insurer);
      row.push(member.MemberID);
      row.push(member.MemberName);
      row.push(member.GroupNumber);
      row.push(member.GroupName);
      row.push(member.IPANumber);
      row.push(member.IPAName);
      row.push(member.PCPNPI);
      row.push(member.PCPName);
      row.push(member.Sex);
      row.push(moment(member.Birthdate).format("MM/DD/YYYY"));
      row.push(member.Stage);
      row.push(member.Status);
      row.push(member.StatusContact);
      row.push(member.StatusReason);
      row.push(member.SubStatus);
      row.push(moment(member.ReferenceDate).format("MM/DD/YYYY"));
      row.push(member.AdmisionDischarge);
      row.push(member.DateAdmission?moment(member.DateAdmission).format("MM/DD/YYYY"):"");
      row.push(member.DateDischarge?moment(member.DateDischarge).format("MM/DD/YYYY"):"");
      row.push(member.EvaluationDate?moment(member.EvaluationDate).format("MM/DD/YYYY"):"");
      row.push(member.Comment1);
      row.push(member.Comment2);
      row.push(member.Comment3);
      row.push(member.Comment4);
      data.push(row);
    }
    //Create workbook and worksheet
    const workbook = new ExcelJS.Workbook();
    workbook.creator = "PatientCare";
    workbook.lastModifiedBy = "PatientCare";
    workbook.created = new Date();
    workbook.modified = new Date();
    workbook.lastPrinted = new Date();

    const worksheet = workbook.addWorksheet("Report");

    //Add Row and formatting
    let reportTitleRow = (worksheet.getCell("H1").value = reportTitle);
    let reportDateRow = (worksheet.getCell("H2").value = reportDate);
    let medicalOfficeRow = (worksheet.getCell("H3").value = medicalOffice);
    let reportRangeDateRow = (worksheet.getCell("H4").value = reportRangeDate);

    // Set font, size and style in title row.
    worksheet.mergeCells("H1:I1");
    worksheet.mergeCells("H2:I2");
    worksheet.mergeCells("H3:I3");
    worksheet.mergeCells("H4:I4");

    worksheet.getCell("H1").font = font;
    worksheet.getCell("H2").font = font;
    worksheet.getCell("H3").font = font;
    worksheet.getCell("H4").font = font;

    worksheet.getCell("H1").alignment = alignment;
    worksheet.getCell("H2").alignment = alignment;
    worksheet.getCell("H3").alignment = alignment;
    worksheet.getCell("H4").alignment = alignment;

    //Add logo
    var img = new Image();

    img.onload = function () {
      var canvas: any = document.createElement("CANVAS");
      var ctx = canvas.getContext("2d");
      canvas.height = img.height;
      canvas.width = img.width;
      ctx.drawImage(this, 0, 0);
      var dataURL = canvas.toDataURL("image/png");
      canvas = null;

      //Add Image
      let logo = workbook.addImage({
        base64: dataURL,
        extension: "png",
      });

      worksheet.addImage(logo, "A1:B4");
      worksheet.mergeCells("A1", "B4");

      // Blank Row
      worksheet.addRow([]);

      //Add waitingList row
      let subTitleRow = worksheet.addRow([subtitle]); //subtitle
      worksheet.mergeCells("A6:I6");

      subTitleRow.eachCell((cell, number) => {
        cell.border = {
          top: {
            style: "thin",
            color: {
              argb: "87CEEB",
            },
          },
        };

        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        cell.font = {
          size: 14,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      //Add Header Row
      let headerRow = worksheet.addRow(header);

      // Cell Style : Fill and Border
      headerRow.eachCell((cell, number) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: {
            argb: "87CEEB",
          },
          bgColor: {
            argb: "FFFFFF",
          },
        };
        cell.border = {
          top: {
            style: "thin",
          },
          left: {
            style: "thin",
          },
          bottom: {
            style: "thin",
          },
          right: {
            style: "thin",
          },
        };

        cell.font = {
          size: 12,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      //add data
      worksheet.addRows(data);

      //column width
      worksheet.getColumn(1).width = 30;
      worksheet.getColumn(2).width = 30;
      worksheet.getColumn(3).width = 16;
      worksheet.getColumn(4).width = 16;
      worksheet.getColumn(5).width = 30;
      worksheet.getColumn(6).width = 16;
      worksheet.getColumn(7).width = 30;
      worksheet.getColumn(8).width = 30;
      worksheet.getColumn(9).width = 20;
      worksheet.getColumn(11).width = 20;
      worksheet.getColumn(13).width = 20;
      worksheet.getColumn(14).width = 20;
      worksheet.getColumn(15).width = 20;
      worksheet.getColumn(16).width = 20;
      worksheet.getColumn(17).width = 20;
      worksheet.getColumn(18).width = 20;
      worksheet.getColumn(19).width = 20;
      worksheet.getColumn(20).width = 60;
      worksheet.getColumn(21).width = 60;
      worksheet.getColumn(22).width = 60;
       worksheet.getColumn(23).width = 60;

      //Footer Row
      const footerFill = {
        type: "pattern",
        pattern: "solid",
        fgColor: {
          argb: "FFFFFF",
        },
      };

      var emptyRow = worksheet.addRow([]);
      worksheet.mergeCells(`A${emptyRow.number}:I${emptyRow.number}`);

      let footerRow = worksheet.addRow(["Total: " + data.length + " Members"]);
      footerRow.getCell(1).fill = footerFill;
      worksheet.mergeCells(`A${footerRow.number}:I${footerRow.number}`);

      footerRow.eachCell((cell, number) => {
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        cell.font = {
          size: 12,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      footerRow = worksheet.addRow([
        "service@waitingmed.com · www.waitingmed.com",
      ]);
      footerRow.getCell(1).fill = footerFill;
      worksheet.mergeCells(`A${footerRow.number}:I${footerRow.number}`);

      footerRow.eachCell((cell, number) => {
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        cell.font = {
          size: 12,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      footerRow = worksheet.addRow([
        "Calle Luis Pales Matos FF-15, Levittown, PR 00949",
      ]);
      footerRow.getCell(1).fill = footerFill;
      worksheet.mergeCells(`A${footerRow.number}:I${footerRow.number}`);

      footerRow.eachCell((cell, number) => {
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        cell.font = {
          size: 12,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      emptyRow = worksheet.addRow([]);
      worksheet.mergeCells(`A${emptyRow.number}:I${emptyRow.number}`);
      //save
      workbook.xlsx.writeBuffer().then((data) => {
        let blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        //app.saveAs(blob, fileName + '.xlsx');
        var url = window.URL.createObjectURL(blob);

        var doc = document.createElement("a");
        doc.href = url;
        doc.download = fileName + ".xlsx";
        doc.click();
        window.URL.revokeObjectURL(url);
      });
    };

    img.src = require("../assets/wmpc_logo.png");
  }

  clearFilter() {
    this.filter = this.defaultFilter();
    this.$store.commit("gaps/RESET_FILTER");
    this.getReport();
  }

  mounted() {
    this.getReport();
  }
}
